import { ReactNode } from 'react';
import { Heading } from 'yoso';
import { useMember } from '~/components/Member/Member.hooks';
import profileStyles from '~/components/Status/Bar/StatusBarProfile.module.scss';

export type StatusBarProfileProps = {
  className?: string;
  children?: ReactNode;
};

export const StatusBarProfile = ({ className, children }: StatusBarProfileProps) => {
  const {
    data: { profileImageUrl, nickname },
  } = useMember();
  return (
    <div className={className}>
      <img
        src={profileImageUrl || ''}
        alt={nickname || 'Profile Image'}
        className={profileStyles.image}
        width={50}
        height={50}
      />
      <div className={profileStyles.body}>
        <Heading level={4} className={profileStyles.title}>
          {nickname}
        </Heading>
        <div className={profileStyles.description}>{children}</div>
      </div>
    </div>
  );
};
